import { configurationExtension, generateUseCaseLink, UseCaseMetadata } from "shared-resources";
import { Example } from "./Example";
import { Description } from "./Description";

export const testYourLenses: UseCaseMetadata = {
    Description,
    Example,
    link: generateUseCaseLink("test-your-lenses", "Test Your Lenses"),
    useCaseType: "test",
    bootstrapConfig: {
        callback: (container) => container.provides(configurationExtension),
    },
};
